import { render, staticRenderFns } from "./VoucherImageSelect.vue?vue&type=template&id=a227a472&scoped=true"
import script from "./VoucherImageSelect.vue?vue&type=script&lang=js"
export * from "./VoucherImageSelect.vue?vue&type=script&lang=js"
import style0 from "./VoucherImageSelect.vue?vue&type=style&index=0&id=a227a472&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a227a472",
  null
  
)

export default component.exports